import React from 'react'
import IconBase from '../IconBase'

const svgContent = <svg viewBox="0 0 1024 1024" width="1em" height="1em" focusable="false" fill="currentColor" aria-hidden="true"><path d="M977.96 977.956a47.925 47.925 0 0 1-67.789 0L46.044 113.83a47.925 47.925 0 1 1 67.789-67.789L977.96 910.168a47.925 47.925 0 0 1 0 67.788" /><path d="M46.044 977.956a47.925 47.925 0 0 0 67.788 0L977.96 113.83a47.925 47.925 0 1 0-67.789-67.789L46.044 910.168a47.925 47.925 0 0 0 0 67.788" /></svg>

const Close = React.forwardRef((props, ref) => {
  return (
    <IconBase name="close" {...props} ref={ref}>
      {svgContent}
    </IconBase>
  )
})

Close.displayName = 'IconClose'

export default Close
